// If your package names don't match ours, you only need to update them here.
import VM from 'scratch-vm';
import Renderer from 'scratch-render';
import AudioEngine from 'scratch-audio';
import Storage from '@turbowarp/scratch-storage';
import SVGRenderer from '@turbowarp/scratch-svg-renderer';
import JSZip from '@turbowarp/jszip';

export default {
  VM,
  Renderer,
  AudioEngine,
  Storage,
  SVGRenderer,
  JSZip
};
